import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import u from "./styles/index.cssr.js";
import i from "../../../_mixins/use-style.js";
import d from "../../icon/src/Icon.js";
import f from "../../icons/Close.js";
import { defineComponent as c, h as a } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { toRef as b } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const T = c({
  name: "BaseClose",
  props: {
    isButtonTag: {
      type: Boolean,
      default: !0
    },
    clsPrefix: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    focusable: {
      type: Boolean,
      default: !0
    },
    round: Boolean,
    onClick: Function,
    absolute: Boolean
  },
  setup(e) {
    return i("-base-close", u, b(e, "clsPrefix")), () => {
      const {
        clsPrefix: o,
        disabled: t,
        absolute: n,
        round: s,
        isButtonTag: l
      } = e;
      return a(l ? "button" : "div", {
        type: l ? "button" : void 0,
        tabindex: t || !e.focusable ? -1 : 0,
        "aria-disabled": t,
        "aria-label": "close",
        role: l ? void 0 : "button",
        disabled: t,
        class: [`${o}-base-close`, n && `${o}-base-close--absolute`, t && `${o}-base-close--disabled`, s && `${o}-base-close--round`],
        onMousedown: (r) => {
          e.focusable || r.preventDefault();
        },
        onClick: e.onClick
      }, a(d, {
        clsPrefix: o
      }, {
        default: () => a(f, null)
      }));
    };
  }
});
export {
  T as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/close/src/Close.js
// module id = 213
// module chunks = 67